namespace $.$$ {
	export class $shm_showcase_table extends $.$shm_showcase_table {
		entries() { return $shm_showcase_entries }
		row_ids() { return this.entries().map( entry => [ entry.id ] ) }
		col_type() { return 'text' }
		col_head_content( id: string ) {
			return [ { number: '№', title: 'Название', fqn: 'FQN', preview: 'Пример', description: 'Описание' }[ id ] ?? id ]
		}
		entry( id: string ) { return this.entries().find( entry => entry.id === id )! }
		entry_title( id: string ) { return this.entry( id ).title }
		entry_arg( id: string ) { return { component: id } }
		preview_id( id: string ) { return id }
		cell_column( id: { col: string } ) { return id.col }
		cell_content( id: { row: string[], col: string } ) {
			const entry = this.entry( id.row[ 0 ] )
			switch( id.col ) {
				case 'number': return [ this.entries().indexOf( entry ) + 1 ]
				case 'title': return [ this.Name( entry.id ) ]
				case 'fqn': return [ $shm_showcase_fqn( entry ) ]
				case 'preview': return [ this.Preview( entry.id ) ]
				default: return [ entry.description ]
			}
		}
	}
}
